import { Tooltip } from 'yoc-ui-library';
import { CalendarOutlined, FlagOutlined, InfoCircleOutlined } from 'yoc-ui-library/icons';

import { useIsMobile } from '@common/hooks';
import type { ISectionComponentProps } from '@components/ReportContent/types';

import style from './styles.module.scss';

const IntroSection = ({ sectionData }: ISectionComponentProps) => {
  const isMobile = useIsMobile();

  if (!('logo_image' in sectionData)) {
    return <div>Error: Invalid data for Intro section.</div>;
  }

  return (
    <div className={style.wrapper}>
      <div className={style['title-section-container']}>
        {isMobile && <h1 className={style['section-title']}>INTRO</h1>}
        <div className={style['card-container']}>
          <div className={style.card}>
            <h1 className={style.title}>CAMPAIGN REVIEW</h1>
            <span className={style.line} />
            <h2 className={style.subtitle}>{sectionData.agency}</h2>
            <div className={style['detail-container']}>
              <span className={style.detail}>
                <CalendarOutlined />
                {sectionData.start_date} - {sectionData.end_date}
              </span>
              |
              <span className={style.detail}>
                <FlagOutlined />
                {sectionData.company}
                {!isMobile && (
                  <Tooltip title={sectionData.campaign_name}>
                    <InfoCircleOutlined />
                  </Tooltip>
                )}
              </span>
            </div>
            <div className={style.footer}>
              {sectionData.company} | {sectionData.year}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroSection;
